define([],
    function() {
        function isZero(val) {
            return val === undefined || val === null || Math.abs(val) < 0.1;
        }

        function formatAsLargeInteger(n) {
            // this should give us commas for every ^3, etc.
            return n.toLocaleString('en-US');
        }

        function formatAsOneDecimalNumber(n) {
            return n.toFixed(1);
        }

        function formatAsOneDecimalPercentage(n) {
            return formatAsOneDecimalNumber(n) + '%';
        }

        /**
         * Returns a percentage fraction from a given numerator and denominator, locks to 100 or 0 when the denominator is zero-ish.
         */
        function cleanPercentageFraction(p, q) {
            if (isZero(q)) {
                return isZero(p) ? 0 : 100;
            } else {
                return p * 100.0 / q;
            }
        }

        // from mustache.js: https://github.com/janl/mustache.js/blob/38b1448/mustache.js#L73
        var entityMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;',
            '`': '&#x60;',
            '=': '&#x3D;'
        };
        function escapeHtml (string) {
            return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
                return entityMap[s];
            });
        }

        return {
            cleanPercentageFraction: cleanPercentageFraction,

            asReviewCount: formatAsLargeInteger,

            asPercentage: formatAsOneDecimalPercentage,

            asNetCsatScore: formatAsOneDecimalNumber,

            asResponseRate: formatAsOneDecimalNumber,

            asReviewCountOrDash: function(val) {
                return isZero(val) ? '-' : formatAsLargeInteger(val);
            },

            asPercentageOrDash: function(val) {
                return isZero(val) ? '-' : formatAsOneDecimalPercentage(val);
            },

            safeText: escapeHtml
        }
    }
);
